import axios, { AxiosInstance, AxiosError } from 'axios';
import { PageError } from '../extensions/PageError';

export interface ProblemDetails {
  detail: string;
  status: number;
  title: string;
  type: string;
}

export interface UserInfo{
  email: string;
}

export class OAuthApiClient {
  private getAccessTokenHeaders: () => Promise<any>;
  private apiClient: AxiosInstance;
  constructor(baseUrl: string, authentication: any) {
    this.getAccessTokenHeaders = authentication.getAccessTokenHeaders;
    this.apiClient = axios.create({
      baseURL: baseUrl,
      responseType: 'json',
      headers: { 'Content-Type': 'application/json' }
    });
  }

  public Post = async <RQ, RS>(path: string, data: RQ): Promise<RS> => {
    const config = await this.Config();
    const response = await this.apiClient.post<RS>(path, data, config).catch(this.ConvertToError);
    return response.data;
  };

  public Patch = async <RQ, RS>(path: string, data: RQ): Promise<RS> => {
    const config = await this.Config();
    const response = await this.apiClient.patch<RS>(path, data, config).catch(this.ConvertToError);
    return response.data;
  };

  public Get = async <RS>(path: string, headers?: any): Promise<RS> => {
    const config = await this.Config(headers);
    const response = await this.apiClient.get<RS>(path, config).catch(this.ConvertToError);
    return response.data;
  };

  public UserInfo = async(authUrl: string): Promise<UserInfo>  => {
    return this.Get<UserInfo>(`${authUrl}/connect/userinfo`);
  }

  private Config = async (headers?: any) => {
    headers = headers || {};
    const authHeaders = await this.getAccessTokenHeaders();
    return { 
      headers: { 
      ...authHeaders,
      ...headers
      } 
    };
  }

  private ConvertToError = (error: AxiosError<ProblemDetails>) => {
    if (!error.response) throw new PageError('Service Unavailable', {});
    
    if (!error.response.data)
      throw new PageError('', {
        Status: `${error.response!.statusText} (${error.response!.status})`,
      });
    
    throw new PageError('', {
      Status: `${error.response!.statusText} (${error.response!.status})`,
      Detail: error.response.data.detail,
    });
  };
}
